import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { MenuGroup as MenuGroup$1 } from "@sanity/ui";
const MenuGroup = (props) => {
  const $ = c(2);
  let t0;
  return $[0] !== props ? (t0 = /* @__PURE__ */ jsx(MenuGroup$1, { ...props, fontSize: 1, padding: 3 }), $[0] = props, $[1] = t0) : t0 = $[1], t0;
}, BASE_URL = "https://docs.sanity.io/help/";
function generateHelpUrl(slug) {
  return BASE_URL + slug;
}
export {
  MenuGroup,
  generateHelpUrl
};
//# sourceMappingURL=generate-help-url.esm.mjs.map
